import { render, staticRenderFns } from "./SettingDemand.vue?vue&type=template&id=9995cc5a&"
import script from "./SettingDemand.vue?vue&type=script&lang=js&"
export * from "./SettingDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports